<template>
    <div class="lb-accordion">
        <div ref="collapsibles" id="accordion_new_object" class="pb-4 pt-1">
            
            <!-- Card 1 section -->
            <article class="message">
                <div class="message-header has-text-black">
                    <a id="information_link" style="width: 100%" :ref="'information'" class="is-active">
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i class="mdi mdi-32px mdi-numeric-1-circle-outline"></i>
                                            </span>
                                            <span class="ml-2 mt-1">{{$t('object_1_data')}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="level-right">
                                <!--<div class="level-item">
                                    <span ref="information-icon" class="icon is-medium mr-1">
                                        <i class="mdi mdi-32px" :class=" isOpen('information') ? 'mdi-plus' : 'mdi-minus' "></i>
                                    </span>
                                </div>-->
                            </div>
                        </nav>
                    </a>
                </div>
                <div id="accordion_new_object-information" class="message-body new-object is-collapsible" data-parent="accordion_new_object" data-allow-multiple="true" >
                    <div class="message-body-content px-4 py-4">
                        <!-- errors section -->
                        <div class="mt-4">
                            <div class="notification is-danger is-light" v-for="(error, index) in imagesErrors" :key="index">
                                <button class="delete" @click="removeMessage('images', index)" ></button>
                                <div v-html="error" />
                            </div>
                        </div>

                        <!-- content type selection -->
                        
                        <div class="pb-2 level">
                            <div class="level-left">
                                <label class="secondary-font level-item">{{$t('select_memory_card_type')}}</label>
                            </div>
                            <div class="level-right is-flex-grow-1 ml-4">
                                <div class="select is-fullwidth level-item">
                                    <select v-model="selectedCard1Type">
                                        <option :key="option" v-for="option in AvailableTypes" :value="option" >{{$t(`memory_card_type_${option}`)}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <!-- END content type selection -->

                        <!-- content type IMAGE -->
                         <div :class="canShowCard1Image?'showing':'hidden'">
                            <vue-dropzone 
                                ref="imagesDropzone" 
                                id="dropzone" 
                                :options="imagesDropzoneOptions" 
                                :useCustomSlot="true" 
                                class="my-4"
                                :class="{'dz-max-files-reached' : hasImage }" 
                                @vdropzone-success="imageAdded" 
                                @vdropzone-error="uploadImageError" 
                                @vdropzone-removed-file="imageRemoved"
                            >
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">
                                        {{ $t('drag_and_drop_image_here') }}
                                    </h3>
                                </div>
                            </vue-dropzone>
                            <div class="visualizacao sortable dropzone-previews"></div>

                            <!-- preview template -->
                            <div class="preview" style="display: none" ref="image-preview-template" id="image-preview-template">
                                <li>
                                    <div>
                                        <div class="dz-preview dz-file-preview">
                                            <figure class="image is-1by1">
                                                <img data-dz-thumbnail />
                                            </figure>
                                            <div class="dz-filename is-size-7">
                                                <span data-dz-name=""></span>
                                            </div>
                                            <div class="dz-progress">
                                                <span
                                                    class="dz-upload"
                                                    data-dz-uploadprogress
                                                ></span>
                                            </div>
                                            <div class="dz-success-mark">
                                                <span class="icon is-small has-text-primary mt-1">
                                                    <i class="mdi mdi-18px mdi-check-circle-outline"></i>
                                                </span>
                                            </div>
                                            <div class="dz-error-mark">
                                                <span>✘</span>
                                            </div>
                                            <div class="dz-error-message">
                                                <span data-dz-errormessage></span>
                                            </div>
                                            <a class="dz-remove" data-dz-remove="">
                                                <span class="icon is-small has-text-danger mt-1">
                                                    <i class="mdi mdi-18px mdi-trash-can"></i> </span
                                            ></a>
                                        </div>
                                    </div>
                                </li>
                            </div>
                        </div>
                        <!-- END content type IMAGE -->

                        <!-- content type TEXT -->
                        <div :class="canShowCard1Text?'showing':'hidden'">
                            <div
                                class="field mb-5"
                                v-if="model.description || content.description"
                                
                            >
                                <div class="control">
                                    <input-rich-text
                                        class="lb-bordered"
                                        v-if="model.description"
                                        v-model="content.description"
                                        :editable="true"
                                        :placeholder="$t('memory_card_text_title')"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- END content type TEXT -->

                        <!-- content type AUDIO -->
                        <div class="audioZone" :class="canShowCard1Audio?'showing':'hidden'">
                            <vue-dropzone
                                ref="audioDropzone"
                                id="audio-dropzone"
                                :options="audioDropzoneOptions"
                                :useCustomSlot="true"
                                class="my-4"
                                :class="{ 'dz-max-files-reached' : hasAudio}"
                                @vdropzone-error="uploadAudioError"
                                @vdropzone-success="audioFileAdded"
                                @vdropzone-removed-file="audioRemoved"
                            >
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">{{ $t( 'Object.drag_and_drop_audio_file_here' ) }}</h3>
                                    <p class="subtitle is-size-7 has-text-grey"> {{ $t('Object.upload_audio_desc') }}</p>
                                </div>
                            </vue-dropzone>

                            <ul class="audio-preview-file dropzone-previews"></ul>

                            <!-- preview template -->
                            <div
                                class="preview"
                                style="display: none"
                                ref="audio-preview-template"
                                id="audio-preview-template"
                            >
                                <li>
                                    <div>
                                        <div class="dz-preview dz-file-preview">
                                            <div class="dz-progress">
                                                <span
                                                    class="dz-upload"
                                                    data-dz-uploadprogress
                                                ></span>
                                            </div>
                                            <div
                                                class="columns is-mobile is-vcentered"
                                            >
                                                <div class="column is-10 px-5 py-5">
                                                    <div
                                                        class="dz-filename is-size-6"
                                                    >
                                                        <span
                                                            data-dz-name=""
                                                        ></span>
                                                    </div>
                                                    <div class="dz-size is-size-7">
                                                        <span
                                                            data-dz-size=""
                                                        ></span>
                                                    </div>
                                                </div>
                                                <div
                                                    class="column is-2 has-text-right pr-5"
                                                >
                                                    <a
                                                        class="dz-remove"
                                                        data-dz-remove=""
                                                    >
                                                        <span
                                                            class="icon has-text-danger mt-1"
                                                        >
                                                            <i
                                                                class="mdi mdi-24px mdi-trash-can"
                                                            ></i> </span
                                                    ></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </div>
                        </div>
                        <!-- END content type AUDIO -->

                        <div class="pb-4 pt-4">
                            <label class="secondary-font">
                                {{$t('use_data_for_cupple')}}
                                <label class="switch ml-1 is-pulled-right">
                                    <input
                                        v-model="duplicateData"
                                        type="checkbox"
                                    />
                                    <span class="slider round"></span>
                                </label>
                            </label>
                        </div>
                        
                    </div>
                </div>
            </article>

            <!-- Card 2 section -->
            <article class="message" :class="duplicateData?'hidden':'showing'">
                <div class="message-header has-text-black">
                    <a id="information2_link" style="width: 100%" :ref="'information2'" class="is-active">
                        <nav class="level">
                            <div class="level-left">
                                <div class="level-item">
                                    <div class="level-item section-title">
                                        <span class="icon-text">
                                            <span class="icon is-medium">
                                                <i class="mdi mdi-32px mdi-numeric-2-circle-outline"></i>
                                            </span>
                                            <span class="ml-2 mt-1">{{$t('object_2_data')}}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="level-right">
                               <!-- <div class="level-item">
                                    <span ref="information2-icon" class="icon is-medium mr-1">
                                        <i class="mdi mdi-32px" :class=" isOpen('information2') ? 'mdi-plus' : 'mdi-minus' "></i>
                                    </span>
                                </div>-->
                            </div>
                        </nav>
                    </a>
                </div>
                <div id="accordion_new_object-information2" class="message-body new-object is-collapsible" data-parent="accordion_new_object" data-allow-multiple="true" >
                    
                    <div class="message-body-content px-4 py-4">

                         <!-- errors section -->
                         <div class="mt-4">
                            <div class="notification is-danger is-light" v-for="(error, index) in imagesErrors" :key="index">
                                <button class="delete" @click="removeMessage('images', index)" ></button>
                                <div v-html="error" />
                            </div>
                        </div>

                        <!-- content type selection -->
                    
                        <div class="pb-2 level">
                            <div class="level-left">
                                <label class="secondary-font level-item">{{$t('select_memory_card_type')}}</label>
                            </div>
                            <div class="level-right is-flex-grow-1 ml-4">
                                <div class="select is-fullwidth level-item">
                                    <select v-model="selectedCard2Type">
                                        <option :key="option" v-for="option in AvailableTypes" :value="option" >{{$t(`memory_card_type_${option}`)}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <!-- END content type selection -->

                        <!-- content type IMAGE -->
                        <div :class="canShowCard2Image?'showing':'hidden'">
                            <vue-dropzone 
                                ref="images2Dropzone" 
                                id="dropzone2" 
                                :options="images2DropzoneOptions" 
                                :useCustomSlot="true" 
                                class="my-4" 
                                :class="{ 'dz-max-files-reached' : hasImage2 }"
                                @vdropzone-success="image2Added" 
                                @vdropzone-error="uploadImage2Error" 
                                @vdropzone-removed-file="image2Removed"
                            >
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">
                                        {{ $t('drag_and_drop_image_here') }}
                                    </h3>
                                </div>
                            </vue-dropzone>
                            <div class="visualizacao2 sortable dropzone-previews"></div>

                            <!-- preview template -->
                            <div class="preview" style="display: none" ref="image-preview-template" id="image2-preview-template">
                                <li>
                                    <div>
                                        <div class="dz-preview dz-file-preview">
                                            <figure class="image is-1by1">
                                                <img data-dz-thumbnail />
                                            </figure>
                                            <div class="dz-filename is-size-7">
                                                <span data-dz-name=""></span>
                                            </div>
                                            <div class="dz-progress">
                                                <span
                                                    class="dz-upload"
                                                    data-dz-uploadprogress
                                                ></span>
                                            </div>
                                            <div class="dz-success-mark">
                                                <span class="icon is-small has-text-primary mt-1">
                                                    <i class="mdi mdi-18px mdi-check-circle-outline"></i>
                                                </span>
                                            </div>
                                            <div class="dz-error-mark">
                                                <span>✘</span>
                                            </div>
                                            <div class="dz-error-message">
                                                <span data-dz-errormessage></span>
                                            </div>
                                            <a class="dz-remove" data-dz-remove="">
                                                <span class="icon is-small has-text-danger mt-1">
                                                    <i class="mdi mdi-18px mdi-trash-can"></i> </span
                                            ></a>
                                        </div>
                                    </div>
                                </li>
                            </div>
                        </div>
                        <!-- content type IMAGE -->

                         <!-- content type TEXT -->
                         <div :class="canShowCard2Text?'showing':'hidden'">
                            <div
                                class="field mb-5"
                                v-if="model.description || content.description"
                                
                            >
                                <div class="control">
                                    <input-rich-text
                                        class="lb-bordered"
                                        v-if="model.description"
                                        v-model="content.pairWith.description"
                                        :editable="true"
                                        :placeholder="$t('memory_card_text_title')"
                                    />
                                </div>
                            </div>
                        </div>
                        <!-- END content type TEXT -->

                        <!-- content type AUDIO -->
                        <div class="audioZone" :class="canShowCard2Audio?'showing':'hidden'">
                            <vue-dropzone
                                ref="audio2Dropzone"
                                id="audio2-dropzone"
                                :options="audio2DropzoneOptions"
                                :useCustomSlot="true"
                                class="my-4"
                                :class="{'dz-max-files-reached' : hasAudio2}"
                                @vdropzone-error="uploadAudio2Error"
                                @vdropzone-success="audio2FileAdded"
                                @vdropzone-removed-file="audio2Removed"
                            >
                                <div class="dropzone-custom-content">
                                    <h3 class="dropzone-custom-title">{{ $t( 'Object.drag_and_drop_audio_file_here' ) }}</h3>
                                    <p class="subtitle is-size-7 has-text-grey"> {{ $t('Object.upload_audio_desc') }}</p>
                                </div>
                            </vue-dropzone>

                            <ul class="audio2-preview-file dropzone-previews"></ul>

                            <!-- preview template -->
                            <div
                                class="preview"
                                style="display: none"
                                ref="audio2-preview-template"
                                id="audio2-preview-template"
                            >
                                <li>
                                    <div>
                                        <div class="dz-preview dz-file-preview">
                                            <div class="dz-progress">
                                                <span
                                                    class="dz-upload"
                                                    data-dz-uploadprogress
                                                ></span>
                                            </div>
                                            <div
                                                class="columns is-mobile is-vcentered"
                                            >
                                                <div class="column is-10 px-5 py-5">
                                                    <div
                                                        class="dz-filename is-size-6"
                                                    >
                                                        <span
                                                            data-dz-name=""
                                                        ></span>
                                                    </div>
                                                    <div class="dz-size is-size-7">
                                                        <span
                                                            data-dz-size=""
                                                        ></span>
                                                    </div>
                                                </div>
                                                <div
                                                    class="column is-2 has-text-right pr-5"
                                                >
                                                    <a
                                                        class="dz-remove"
                                                        data-dz-remove=""
                                                    >
                                                        <span
                                                            class="icon has-text-danger mt-1"
                                                        >
                                                            <i
                                                                class="mdi mdi-24px mdi-trash-can"
                                                            ></i> </span
                                                    ></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </div>
                        </div>
                        <!-- END content type AUDIO -->




                    </div>
                </div>
            </article>

            

            
        </div>

        <div v-if="errorsOnSave" class="validationErrors px-5">
            <div class="notification is-danger is-light">
                <button class="delete" @click="errorsOnSave = false"></button>
                <p class="has-text-weight-bold is-size-6 pb-2">
                    {{ $t('Object.errors_on_save') }}
                </p>
                <p class="is-size-6">
                    {{ $t('Object.errors_on_save_desc') }}
                </p>
                <br />
                <p
                    class="is-size-6 has-text-italic"
                    v-for="(error, index) in objectErrors"
                    :key="index"
                >
                    - {{ error }}
                </p>
                <p
                    class="is-size-6 has-text-italic"
                    v-for="(error, index) in pairWithErrors"
                    :key="index+'2'"
                >
                    - {{ error }}
                </p>
            </div>
        </div>

        <div
            v-if="canDelete"
            class="delete-button is-pulled-right px-2 pb-2 mr-2"
        >
            <a @click="deleteObject" class="primary-font button is-primary is-inverted">
                <span class="pr-4 is-size-6">{{ deleteText }}</span>
                <span class="icon"
                    ><i
                        class="mdi mdi-32px mdi-close-circle"
                        aria-hidden="true"
                    ></i
                ></span>
            </a>
        </div>

        <div class="action-buttons-container mb-2">
            <a @click="discardUnsavedChanges" class="button is-primary">
                <span class="icon is-small my-2"
                    ><i
                        class="mdi mdi-32px mdi-chevron-double-left"
                        aria-hidden="true"
                    ></i
                ></span>
            </a>
            
            <a
                @click="validateAndSave"
                class="button is-primary primary-font is-size-5 is-pulled-right mr-5"
            >
                {{ $t('Buttons.save') }}
            </a>
           
        </div>
        <l-projectObject-modal-preview
            v-if="showModalPreview"
            :type="previewType"
            :content="previewData"
            :active.sync="showModalPreview"
            @close="showModalPreview = false"
        />

        <l-project-object-preview
            :object="content"
            v-if="showPreviewModal"
            @close="showPreviewModal = false"
        />
    </div>
</template>

<script>
import bulmaCollapsible from '@creativebulma/bulma-collapsible';
import InputRichText from '@/components/InputRichText';
import _ from 'underscore';
import GeoCodingOSM from 'geocoding-osm';
import tippy, { createSingleton } from 'tippy.js';
import vue2Dropzone from 'vue2-dropzone';
import draggable from 'vuedraggable';
import LProjectObjectModalPreview from '@/components/LProjectObjectModalPreview';
import LProjectObjectInputTags from '@/components/LProjectObjectInputTags';
import LProjectObjectPreview from '@/components/LProjectObjectPreview';
import InputURL from '@/components/InputURL';
import LObjectCardRelated from '@/components/LObjectCardRelated';

//import from 'search-osm-batch'
export default {
    name: 'LProjectMemoryObject',
    components: {
        InputRichText,
        vueDropzone: vue2Dropzone,
        draggable,
        LProjectObjectInputTags,
        LProjectObjectModalPreview,
        LProjectObjectPreview,
        InputURL,
        LObjectCardRelated,
    },
    props: {
        content: {
            type: Object,
            default() {
                return {};
            },
        },
        model: {
            type: Object,
            default() {
                return {};
            },
        },
        hasLocation: {
            type: Boolean,
            default: false,
        },
        mapPositionActivation: {
            type: Boolean,
            default: false,
        },
        canHasLocation: {
            type: Boolean,
            default: true,
        },
        objectType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            searchText: '',
            activePoint: undefined,
            lat: '',
            lon: '',
            mapPositionActive: false,
            imagesDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                maxFiles: 1,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.visualizacao',
                parallelUploads: 1,
                //disablePreviews: true,
                acceptedFiles: 'image/gif,image/jpeg,image/png',
                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            images2DropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                maxFiles: 1,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.visualizacao2',
                parallelUploads: 1,
                //disablePreviews: true,
                acceptedFiles: 'image/gif,image/jpeg,image/png',
                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },

            showModalPreview: false,
            previewType: undefined,
            previewData: undefined,

            showPreviewModal: false,

            saving: false,
            originalContent: {},
            originalPairWith: {},

            objectErrors: {},
            pairWithErrors: {},
            filesErrors: [],
            audioErrors: [],
            imagesErrors: [],
            errorsOnSave: false,
            collapsibles: undefined,
            duplicateData: true,
            AvailableTypes: ['text','image','audio'],
            selectedCard1Type: "image",
            selectedCard2Type: "image",

            audioDropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                maxFiles: 1,
                //headers: { 'My-Awesome-Header': 'header value' },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.audio-preview-file',
                acceptedFiles: 'audio/mpeg',

                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },
            showAudioPlayer: false,
            audioFile: '',

            audio2DropzoneOptions: {
                url: `${process.env.VUE_APP_ROOT_API}/api/V1/upload/`,
                thumbnailWidth: 150,
                maxFilesize: 4,
                maxFiles: 1,
                //headers: { 'My-Awesome-Header': 'header value' },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
                previewsContainer: '.audio2-preview-file',
                acceptedFiles: 'audio/mpeg',

                dictDefaultMessage: this.$t('dropzone.dict_default_message'),
                dictFallbackMessage: this.$t('dropzone.dict_fallback_message'),
                dictFallbackText: this.$t('dropzone.dict_fallback_text'),
                dictFileTooBig: this.$t('dropzone.dict_file_too_big'),
                dictInvalidFileType: this.$t('dropzone.dict_invalid_file_type'),
                dictResponseError: this.$t('dropzone.dict_response_error'),
                dictCancelUpload: this.$t('dropzone.dict_cancel_upload'),
                dictCancelUploadConfirmation: this.$t(
                    'dropzone.dict_cancel_upload_confirmation'
                ),
                dictRemoveFile: this.$t('dropzone.dict_remove_file'),
                dictMaxFilesExceeded: this.$t(
                    'dropzone.dict_max_files_exceeded'
                ),
            },

        };
    },
    computed: {
        hasImage() {
            if (this.content) {
                return this.content.images && this.content.images.length > 0;
            }
            return false;
        },
        hasImage2() {
            if (this.content.pairWith) {
                return this.content.pairWith.images && this.content.pairWith.images.length > 0;
            }
        },
        hasAudio() {
            return this.content['audio'] && Object.keys(this.content['audio']).length > 0;
        },
        hasAudio2() {
            return this.content.pairWith['audio'] && Object.keys(this.content.pairWith['audio']).length > 0;
        },
        isEdition() {
            return this.content && this.content._id != 'draft';  
        },
        canAddAudio() {
          return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.object.canAddAudio : false  
        },
        canShowCard1Text() {
            return this.selectedCard1Type == 'text';
        },
        canShowCard1Image() {
            return this.selectedCard1Type == 'image';
        },
        canShowCard1Audio() {
            return this.selectedCard1Type == 'audio';
        },
        canShowCard2Text() {
            return this.selectedCard2Type == 'text';
        },
        canShowCard2Image() {
            return this.selectedCard2Type == 'image';
        },
        canShowCard2Audio() {
            return this.selectedCard2Type == 'audio';
        },
        canAddImages() {
          return this.$store.getters.activePlan ? this.$store.getters.activePlan.configuration.object.canAddImages : false  
        },
        
        titleRows(){
            return 1;
        },
        hasAccess() {
            if (this.isCreation) {
                return true;
            }
            return this.content.accessLevel == 'administrator';
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        titlePlaceholder() {
            return 'creation.title_hint';
        },
        hasChanges() {
            return this.content !== this.originalContent;
        },
        
        canDelete() {
            return this.content._id != 'draft' && this.hasAccess;
        },
        deleteText(){
            return this.$t('remove_object');
        }
    },
    watch: {
        
    },
    mounted() {
        // console.log('mounted object', this.model);
        //this.collapsibles = bulmaCollapsible.attach('.new-object');

        /*const tippyInstances = tippy('[data-tippy-content]');
        const singleton = createSingleton(tippyInstances, {
            delay: 100,
            moveTransition: 'transform 0.2s ease-out',
            placement: 'right',
            theme: 'tippyeduloc',
            allowHTML: true,
            trigger: 'click',
            animation: 'shift-away',
            offset: [0, 20],
        });*/
        // console.log('is edition?',this.isEdition)
        if (this.isEdition) {
            
            this.duplicateData = false;
        }

        if (this.canAddImages) {

            this.$refs['imagesDropzone'].setOption(
                'previewTemplate',
                document.getElementById('image-preview-template').innerHTML
            );

            this.$refs['images2Dropzone'].setOption(
                'previewTemplate',
                document.getElementById('image2-preview-template').innerHTML
            );

            // console.log("object data",this.content)

            if (this.content.images) {
                this.content.images.forEach((image) => {
                    let file = {
                        size: image.size,
                        name: image.name,
                        type: image.mimeType,
                        draggable: true,
                    };
                    let url = image.url;
                    this.$refs['imagesDropzone'].manuallyAddFile(file, url);
                    this.selectedCard1Type = "image";
                });
            }

            if (this.content.pairWith) {
                if (this.content.pairWith.images) {
                    this.content.pairWith.images.forEach((image) => {
                        let file = {
                            size: image.size,
                            name: image.name,
                            type: image.mimeType,
                            draggable: true,
                        };
                        let url = image.url;
                        this.$refs['images2Dropzone'].manuallyAddFile(file, url);
                        this.selectedCard2Type = "image";
                    });
                }
            }
        
        }

        if (this.canAddAudio) {
            this.$refs['audioDropzone'].setOption(
                'previewTemplate',
                document.getElementById('audio-preview-template').innerHTML
            );

            if (this.content.audio) {
                let file = {
                    size: this.content.audio.size,
                    name: this.content.audio.name,
                    type: this.content.audio.mimeType,
                    draggable: true,
                };
                let url = this.content.audio.url;
                this.$refs['audioDropzone'].manuallyAddFile(file, url);
                this.selectedCard1Type = "audio";
            }

            this.$refs['audio2Dropzone'].setOption(
                'previewTemplate',
                document.getElementById('audio2-preview-template').innerHTML
            );

            if (this.content.pairWith) {
                if (this.content.pairWith.audio) {
                    let file = {
                        size: this.content.pairWith.audio.size,
                        name: this.content.pairWith.audio.name,
                        type: this.content.pairWith.audio.mimeType,
                        draggable: true,
                    };
                    let url = this.content.pairWith.audio.url;
                    this.$refs['audio2Dropzone'].manuallyAddFile(file, url);
                    this.selectedCard2Type = "audio";
                }
            }

            

        
        }

        if (this.content.description) {
            this.selectedCard1Type = "text";
        }

        if (this.content.pairWith) { 
            if (this.content.pairWith.description) {
                this.selectedCard2Type = "text";
            }
        }


        this.originalContent = { ...this.content };
        this.originalPairWith = { ...this.content.pairWith };

        /*this.$nextTick(() => {
            setTimeout(() => {
                this.collapsibles.forEach((collapsibleInstance) => {
                    collapsibleInstance.expand();
                });
                //this.$refs['titleObject'].focus();
            }, 500);
        });*/
    },
    beforeDestroy() {
    },
    destroyed() {},
    methods: {
        removeMessage(type, index) {
            if (type == 'files') {
                this.filesErrors.splice(index, 1);
            } else if (type == 'audio') {
                this.audioErrors.splice(index, 1);
            } else if (type == 'images') {
                this.imagesErrors.splice(index, 1);
            }
        },
        isOpen(type) {
            if (this.$refs[type]) {
                if (this.$refs[type].classList.contains('is-active')) {
                    return true;
                }
            }
            return false;
        },
        
        
        validateAndSave() {
            //selectedCard1Type
            //duplicateData
            switch(this.selectedCard1Type) {
                case 'image':
                    // console.log("image",this.content)
                    if (this.content['images'].length > 0) {
                        delete this.content.audio;
                        delete this.content.description;
                    } else {
                        this.objectErrors['images'] = this.$t(
                            `Object.missing_images_value`
                        );
                    }
                    break;
                case 'text':
                    // console.log("text", this.content['description'].length)
                    if (this.content['description'].length > 0) {
                        delete this.content.audio;
                        delete this.content.images;
                    } else{
                        this.objectErrors['images'] = this.$t(
                            `Object.missing_description_value`
                        );
                    }
                    break;
                case 'audio':
                    // console.log("audio", Object.keys(this.content['audio']).length)
                    if (Object.keys(this.content['audio']).length > 0) {
                        delete this.content.images;
                        delete this.content.description;
                    } else {
                        this.objectErrors['images'] = this.$t(
                            `Object.missing_audio_value`
                        );
                    }
                    break;
            }

            if (this.duplicateData) {
                this.content['duplicate'] = this.duplicateData;
                if (this.content.pairWith) {
                    if (!this.isEdition) {
                        this.content.pairWith.title = this.content.title + "2";
                        delete this.content.pairWith.images;
                        delete this.content.pairWith.audio;
                        delete this.content.pairWith.description;
                    }
                }
            } else {
                switch(this.selectedCard2Type) {
                    case 'image':
                        //console.log("image",this.content['images'].length)
                        if (this.content.pairWith.images.length > 0) {
                            delete this.content.pairWith.audio;
                            delete this.content.pairWith.description;
                        } else {
                            this.pairWithErrors['images'] = this.$t(
                                `Object.missing_images_value`
                            );
                        }
                        break;
                case 'text':
                    // console.log("text", this.content.pairWith['description'].length)
                    if (this.content.pairWith['description'].length > 0) {
                        delete this.content.pairWith.audio;
                        delete this.content.pairWith.images;
                    } else{
                        this.pairWithErrors['text'] = this.$t(
                            `Object.missing_description_value`
                        );
                    }
                    break;
                case 'audio':
                    // console.log("audio", Object.keys(this.content.pairWith['audio']).length)
                    if (Object.keys(this.content.pairWith['audio']).length > 0) {
                        delete this.content.pairWith.images;
                        delete this.content.pairWith.description;
                    } else {
                        this.pairWithErrors['audio'] = this.$t(
                            `Object.missing_audio_value`
                        );
                    }
                    break;
            }
                
            }


            // console.log(this.objectErrors);
            const isValid = Object.keys(this.objectErrors).length === 0 && Object.keys(this.pairWithErrors).length === 0;
            if (isValid) {
               this.$emit('saveMemoryObject');
                // console.log('is valid object');
            } else {
                this.errorsOnSave = true;
            }
        },
        
        image2Added(file, response) {
            // console.log('adding file', file, response);
            if (!this.content.pairWith.images) {
                this.content.pairWith.images = [];
            }
            this.content.pairWith.images.push(response.file);
            this.content.pairWith.title = file.name
            //console.log("Content",file)
        },
        imageAdded(file, response) {
            // console.log('adding file', file, response);
            if (!this.content.images) {
                this.content.images = [];
            }
            this.content.images.push(response.file);
            this.content.title = file.name
            //console.log("Content",file)
        },
        imageRemoved(file, error, xhr){
            let removedImage = _.findWhere(this.content.images, {name: file.name, size:file.size});
            this.content.images = _.without(this.content.images, removedImage);
            this.content.title = ""
        },
        image2Removed(file, error, xhr){
            let removedImage = _.findWhere(this.content.pairWith.images, {name: file.name, size:file.size});
            this.content.pairWith.images = _.without(this.content.pairWith.images, removedImage);
            this.content.pairWith.title = ""
        },
        uploadImageError(file, message, xhr) {
            this.$refs['imagesDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.imagesErrors.push(errorMessage);
        },
        uploadImage2Error(file, message, xhr) {
            this.$refs['images2Dropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.images2Errors.push(errorMessage);
        },
        previewImages() {
            // console.log(this.content.images);
            if (this.content.images) {
                this.previewType = 'images';
                this.previewData = this.content.images;
                this.showModalPreview = true;
            }
        },
        previewImages2() {
            // console.log(this.content.images);
            if (this.content.pairWith.images) {
                this.previewType = 'images';
                this.previewData = this.content.pairWith.images;
                this.showModalPreview = true;
            }
        },


        uploadAudioError(file, message, xhr) {
            // console.log(file, message, xhr);
            this.$refs['audioDropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.audioErrors.push(errorMessage);
        },
        audioFileAdded(file, response) {
            this.content.audio = response.file;
        },
        audioRemoved(file, error, xhr){
            delete this.content.audio;
        },
        uploadAudio2Error(file, message, xhr) {
            // console.log(file, message, xhr);
            this.$refs['audio2Dropzone'].removeFile(file);
            const errorMessage = '<i>' + file.name + '</i></br> ' + message;
            this.audioErrors.push(errorMessage);
        },
        audio2FileAdded(file, response) {
            this.content.pairWith.audio = response.file;
        },
        audio2Removed(file, error, xhr){
            delete this.content.pairWith.audio;
        },
        
 
        discardUnsavedChanges() {
            // console.log('discard');
            this.$emit('cancel');
        },

        
        
        
        deleteObject() {
            // console.log("on delete object");
            this.$emit('delete', this.content);
        },
    },
};
</script>

<style scoped>
@import '~tippy.js/animations/shift-away.css';
@import '../assets/css/tippyeduloc.css';
@import '~vue2-dropzone/dist/vue2Dropzone.min.css';
@import '../assets/css/leftPanel.css';
textarea {
    min-height: 3rem !important;
    resize: vertical;
}
.message {
    background-color: transparent;
    border-radius: 0;
    font-size: 1rem;
    margin-bottom: 0;
}
.message-header {
    border-radius: 0;
    padding-right: 0;
    background-color: #f4f4f4;
    border-bottom: 1px solid #d2d2d2;
}

.message
    a:not(.button):not(.lb-button):not(.lb-toolbar-button_images):not(.lb-toolbar-button_video):not(.lb-toolbar-button_files):not(.lb-toolbar-button_audio):not(.lb-toolbar-button_url):not(.lb-toolbar-button_location):not(.lb-toolbar-button_tags):not(.lb-toolbar-button_question):not(.lb-toolbar-button_object):not(.lb-toolbar-button_point):not(.lb-delete-media):not(.lb-answer):not(.lb-multiple-answer):not(.tag):not(.lb-bain-tag-functional):not(.lb-bain-tag-emotional):not(.lb-bain-tag-life-changer):not(.lb-bain-tag-social-impact):not(.lb-role-tag_administrator):not(.lb-role-tag_teacher):not(.lb-role-tag_student):not(.lb-role-tag_coordinator):not(.lb-role-tag_participant):not(.lb-role-tag_facilitator):not(.lb-status-tag_active):not(.lb-status-tag_inactive):not(.lb-status-tag_invited):not(.dropdown-item) {
    text-decoration: none;
}
.message-body.is-collapsible {
    overflow-x: hidden;
}
.action-buttons {
    position: absolute;
    bottom: 11px;
    width: 100%;
    left: 10px;
}
.action-buttons button {
    height: 60px;
}

.lb-bordered {
    border: 1px solid #dbdbdb;
    border-radius: 4px;
    box-shadow: inset 0 0.0625em 0.125em rgb(74 74 74 / 5%);
}

.lb-bordered:hover {
    border: 1px solid #b5b5b5;
}

.lb-bordered:focus-within {
    border: 1px solid #4a4a4a;
}

.lb-bordered /deep/ .buttons {
    border-radius: 4px 4px 0 0;
    margin-bottom: 0;
}
.lb-bordered /deep/ .editor__content {
    padding: 0.75rem;
}
.lb-bordered /deep/ .is-empty.editor-empty {
    display: none;
}
.is-borderless-left {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 0;
}
.is-radiusless-right {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}

.creation-helper:hover {
    cursor: pointer;
}
.creation-helper:hover i {
    /*color: #0074d9;*/
    color: var(--eduloc-red);
}

.dropzone {
    min-height: 80px;
    border-radius: 4px;
    border-width: 1px;
}
.sortable {
    padding: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    list-style-type: none;
}
.sortable li {
    float: left;
    width: 115px;
    height: 115px;
    overflow: hidden;
    border: 1px solid #0074d9;
    text-align: center;
    margin: 5px;
    border-radius: 4px;
}
.sortable li:last-child {
    margin-bottom: 2rem;
}
.sortable li:hover {
    cursor: move;
}
li.sortable-placeholder {
    border: 1px dashed #ccc;
    background: none;
}

.dz-image-preview .dz-remove {
    position: relative;
    bottom: 88px;
    background-color: rgba(255, 255, 255, 0.6);
    float: right;
    padding: 4px;
    border-top-left-radius: 4px;
}
.dz-image-preview .dz-filename {
    position: relative;
    bottom: 113px;
    background-color: rgba(255, 255, 255, 0.6);
    padding-bottom: 2px;
    padding-top: 2px;
}



.validationErrors {
    position: absolute;
    z-index: +1;
    top: 20%;
}

.validationErrors .notification {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.dz-image-preview .dz-preview.dz-file-preview .image.is-1by1 img {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
}

.dz-max-files-reached{
    display: none;
}

.audio-preview-file.dropzone-previews,.audio2-preview-file.dropzone-previews {
    padding: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    list-style-type: none;
}
.audio-preview-file.dropzone-previews li,.audio2-preview-file.dropzone-previews li {
    border: 1px solid #0074d9;
    border-radius: 4px;
}


</style>
